<template>
  <v-layout>

    <v-flex>
      <v-row align="center" no-gutters class="">
        <v-col class="text-left ml-n6 mt-n4">
          <v-breadcrumbs :items="subNavs"></v-breadcrumbs>
        </v-col>
      </v-row>

      <v-card class="pa-6 mt-3">
        <v-card-title>
          Assign Client
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text class="text--primary mt-6">

          <AlertMessage :alerMessage="alerMessage"></AlertMessage>

          <ValidationObserver ref="observer" v-slot="{ validate, reset }">
            <form
              v-on:submit.prevent>
              <v-row class="pb-5">

                <v-col cols="12" md="4">
                  <v-autocomplete
                    v-model="user.sales_agent"
                    :items="agents"
                    :loading="loading"
                    :search-input.sync="search"
                    clearable
                    no-data-text="Sales agent not found"
                    hide-details
                    hide-selected
                    item-text="keyword"
                    outlined
                    label="Assign To"
                    return-object
                  >
                    <template v-slot:no-data>
                      <v-list-item>
                        <v-list-item-title>
                          Enter <strong>Name</strong>
                        </v-list-item-title>
                      </v-list-item>
                    </template>
                    <template v-slot:selection="{ attr, on, item, selected }">
                      <div
                        v-bind="attr"
                        :input-value="selected"
                        color="#A3A8AD"
                        v-on="on">
                          <span v-text="item.first_name + ' ' + item.last_name"></span>
                          <span v-text="item.code" v-if="item.code" class="grey-color ml-2"></span>
                      </div>

                    </template>
                    <template v-slot:item="{ item }">
                      <v-list-item-content>
                        <v-list-item-title v-text="item.first_name + ' ' + item.last_name"></v-list-item-title>
                        <v-list-item-subtitle v-text="item.code"></v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
              <v-row class="pa-0">
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="user.first_name"
                    maxlength="100"
                    :error-messages="errors"
                    label="First Name"
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="user.last_name"
                    maxlength="100"
                    :error-messages="errors"
                    label="Last Name"
                    disabled
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="user.email"
                    maxlength="100"
                    :error-messages="errors"
                    label="Email Address"
                    hint="* Required (e.g. juan.delacruz@email.com)"
                    show-details
                    disabled
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="user.contact_no"
                    maxlength="50"
                    label="Contact No."
                    disabled
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="4">
                  <ValidationProvider v-slot="{ errors }" name="Overseas Warehouse" rules="required">
                    <v-select
                      v-model="user.location_id"
                      :items="locations"
                      menu-props="auto"
                      :error-messages="errors"
                      label="Overseas Warehouse"
                      item-text="name"
                      item-value="id"
                      required
                    ></v-select>
                  </ValidationProvider>
                </v-col>

                <v-col cols="12" md="4">
                  <ValidationProvider v-slot="{ errors }" name="Warehouse" rules="required">
                    <v-select
                      v-model="user.warehouse_id"
                      :items="warehouses"
                      menu-props="auto"
                      :error-messages="errors"
                      label="Warehouse"
                      item-text="name"
                      item-value="id"
                      required
                    ></v-select>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" md="12">
                  <v-textarea
                    v-model="user.address"
                    label="Address"
                    auto-grow
                    rows="1"
                    maxlength="255"
                    disabled>
                  </v-textarea>
                </v-col>
              </v-row>


              <v-btn class="d-none" @click="reset"></v-btn>
            </form>
          </ValidationObserver>

        </v-card-text>
        <v-card-actions>
          <v-btn
            color="primary mr-4"
            depressed
            large
            @click="submit">
            <span class="mx-5">{{ loading ? 'Please wait...' : 'Assign Client' }}</span>
          </v-btn>
          <v-btn
            v-if="!loading"
            depressed
            large
            @click="clear">
            <span class="mx-5">Reset Form</span>
          </v-btn>
        </v-card-actions>
      </v-card>

      <SnackBar :snackbarDetails="snackbarDetails"></SnackBar>

    </v-flex>
  </v-layout>
</template>

<script>
  import SnackBar from '@/components/snackbar/SnackBar.vue'
  import { required, email, max } from 'vee-validate/dist/rules'
  import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
  import AlertMessage from '@/components/AlertMessage.vue'

  setInteractionMode('eager')

  extend('required', {
    ...required,
    message: '{_field_} can not be empty',
  })

  extend('max', {
    ...max,
    message: '{_field_} may not be greater than {length} characters',
  })

  extend('email', {
    ...email,
    message: '{_field_} must be a valid email',
  })

  export default {
    name: 'AssingClientPage',
    data: () => ({
      adminNamespace: 'admin',
      slug: '',
      search: null,
      show1: false,
      loading: false,
      subNavs: [
        {
          text: 'Clients',
          disabled: false,
          exact: true,
          to: {
            name: 'clients'
          },
        },
        {
          text: 'AssignClient',
          disabled: true,
          href: 'breadcrumbs_link_2',
        },
      ],
      alerMessage:{
        show: false,
        status: '',
        type: 'error',
        omitMessage: 'Pos category menu items ',
        messages: []
      },
      snackbarDetails: {
        color: 'sb-success',
        msg: '',
        show: false
      },
      warehouses: [],
      locations: [],
      agents: [],
      user: {
        warehouse_id: '',
        location_id: '',
        sales_agent: ''
      }
    }),
    computed: {
      forUpdate: function(){
        return this.id ? true : false
      }
    },
    methods: {
      getDefaultData () {
        let self = this
        this.$http.plain.get(this.adminNamespace+'/default-data?agents=true&warehouses=true&locations=true')
          .then(response => {
            this.agents = response.data.agents
            this.warehouses = response.data.warehouses
            this.locations = response.data.locations
          })
          .catch(error => {
            console.log(error);
          })
      },
      getUser () {
        this.loading = true
        let self = this
        this.$http.plain.get(this.adminNamespace+'/clients/'+this.slug)
          .then(response => {
            this.user = response.data
          })
          .catch(error => {
            if (error.response) {
              this.alerMessage.messages = error.response.data.messages
              this.alerMessage.show = true
            }else{
              this.showMessage("Something went wrong! Please try again.", 'error')
            }
          })
          .then(function () {
            self.loading = false
          })
        },
      save () {
        let self = this
        let data = {
          sales_agent: this.user.sales_agent.id,
          warehouse_id: this.user.warehouse_id,
          location_id: this.user.location_id
        }
        this.loading = true

        this.$http.secured.post(this.adminNamespace+'/clients/get/'+this.slug, data)
          .then(response => {
            this.$router.push({ name: 'clients', query: { added: true, message:"Client has been successfully assigned to sales agent." } })
          })
          .catch(error => {
            if (error.response) {
              this.alerMessage.messages = error.response.data.messages
              this.alerMessage.show = true
            }else{
              this.showMessage("Something went wrong! Please try again.", 'error')
            }
          })
          .then(function () {
            self.loading = false
          })

      },
      async submit () {

        const isValid = await this.$refs.observer.validate();
        if (!isValid) {
          return false;
        }

        if(this.loading){
          return false;
        }
        this.alerMessage.show = false
        this.save()
      },
      clear () {

        this.user['warehouse_id'] = ''
        this.user['location_id'] = ''
        this.user['sales_agent'] = ''

        this.$refs.observer.reset()
      },
      showMessage(msg, color){
        this.snackbarDetails = {
          color: color,
          msg: msg,
          show: true
        }
      }
    },
    mounted() {
      this.slug = this.$route.params.slug
      this.getUser()
      this.getDefaultData()
    },
    components: {
      ValidationProvider,
      ValidationObserver,
      SnackBar,
      AlertMessage
    }
  }
</script>
